













































import {
  computed,
  defineNuxtComponent,
  vue3Model
} from '~/utils/nuxt3-migration'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import useStatic from '~/compositions/static'
import { ciMarketplace } from '~/icons/source/solid/marketplace'
import { getLiveStaticUrl } from '~/utils/static'
import { defineComponentTranslations } from '~/utils/i18n'
import { useRoute, useRouter } from '@nuxtjs/composition-api'
import { Searchable } from '~/models/search/types'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CExpandableContent,
    CLink,
    CIcon,
    CImg
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const s = useStatic()
    const router = useRouter()
    const route = useRoute()

    const isPreExpanded = route.value.hash === '#categories'

    const categoryId = computed(() => {
      return (
        props.modelValue.searchables.find(
          (item: any) => item.k && item.k.length > 0
        )?.v || ''
      )
    })

    const categories = computed(() => {
      const children =
        props.modelValue.searchables.find(
          (item: any) => item.k && item.k.length > 0
        )?.k || []
      if (children.length > 0) {
        return children.filter((c: Searchable) => c.c > 0)
      }
      return []
    })

    function getImageUrl(category: any) {
      if (props.modelValue.isParts) {
        return s(
          `/nuxt-static/img/quick-search/parts/${categoryId.value}/${category.v}.png`
        )
      }
      return getLiveStaticUrl(
        `/static/images/web/xyma_small/cat-${category.v}.png`
      )
    }

    function handleImageError(e: Event) {
      const target = e.target as HTMLImageElement
      if (target) {
        target.remove()
      }
    }

    function onExpand(isExpanded: boolean) {
      if (isExpanded && route.value.hash === '#categories') {
        return
      }

      router.replace({
        hash: isExpanded ? '#categories' : undefined
      })
    }

    return {
      ciMarketplace,
      categoryId,
      categories,
      isPreExpanded,
      getImageUrl,
      handleImageError,
      onExpand
    }
  },
  i18n: defineComponentTranslations({
    view_all_subcategories: {
      en: 'View all subcategories',
      el: 'Δες όλες τις υποκατηγορίες'
    }
  })
})
